import type { RouteRecordRaw } from 'vue-router';
import { useUserStore } from '@/stores/userStore';
import { useRouter } from 'vue-router';
import { isEmpty } from 'lodash-es';
import { isAdminRole } from '@/utils/users';

const routes: RouteRecordRaw[] = [
	{
		path: '/choose-profile',
		children: [
			{
				path: '',
				name: 'ProfileChooserIndex',
				component: () => import('@/views/ProfileChooserIndex.vue'),
				meta: {
					layout: 'LayoutDefault',
					requiresAuth: true,
					title: 'pageProfileChooser.metaTitle',
				},
				beforeEnter: async () => {
					const router = useRouter();
					const userStore = useUserStore();

					// Ensure profiles are loaded (lazy-load if needed)
					await userStore.ensureUserProfiles();

					const redirect = router.currentRoute.value.query.redirect as string;

					const hasAdminProfile = userStore.userProfiles?.some((profile) => isAdminRole(profile.role_id));
					const noProfiles = !userStore.userProfiles || !userStore.userProfiles[0];

					// Always show chooser for admins or when no profiles exist
					if (hasAdminProfile || !userStore.hasUserAcceptedLatestTermsOfUse || noProfiles) {
						return true;
					}

					// If profile already set (from default profile flow), redirect
					if (userStore.profile) {
						return redirect ? router.push({ path: redirect }) : router.push({ name: userStore.profileDefaultRoute });
					}

					// Auto-select for non-admin users
					const noDefaultProfile = userStore.hasMultipleProfiles && isEmpty(userStore.defaultProfile);
					if (noDefaultProfile) return true; // Show chooser

					await userStore.setProfile(
						userStore.defaultProfile?.uuid ?? userStore.userProfiles![0]!.uuid,
					);

					return redirect ? router.push({ path: redirect }) : router.push({ name: userStore.profileDefaultRoute });
				},
			},
		],
	},
];

export default routes;
